import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { csvDownloadDataAtom } from '@/atoms/exporting';
import { toCsvFilename } from '@/components/export/Export.helper';
import { CsvDownloadOptions } from '@/types/exporting';

export const useCsvDownload = (
  fileName: string,
  url?: string,
  { includeOnDemandMetrics = false, appliedFilters = null }: CsvDownloadOptions = {},
) => {
  const setCsvDownloadData = useSetAtom(csvDownloadDataAtom);

  useEffect(() => {
    if (url) {
      setCsvDownloadData({ url, fileName: toCsvFilename(fileName), includeOnDemandMetrics, appliedFilters });
    }
  }, [url, fileName, includeOnDemandMetrics, appliedFilters]);
};
